import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const base = `${API_URL}/api/analytics/widgets`;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const preview = (csvText) =>
  axios.post(`${base}/sales.import/preview`, { csvText }, { headers: authHeaders(), timeout: 30000 }).then(r => r.data);

// SSE so a long match (one Opus call whose cost scales with distinct customer/product name count)
// on a large file isn't killed by Heroku's router — mirrors services/maintenanceService.js's
// sseStream() helper verbatim; without it this was failing in production as a misleading browser
// CORS/ERR_FAILED error once the call ran past Heroku's 30s router ceiling.
function sseStream(url, body, onProgress) {
  return new Promise(async (resolve, reject) => {
    let response;
    try {
      response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify(body),
      });
    } catch (e) { return reject(e); }
    if (!response.ok) {
      const err = await response.json().catch(() => ({ message: 'Request failed' }));
      return reject(err);
    }
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buf = '';
    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        const parts = buf.split('\n\n');
        buf = parts.pop();
        for (const part of parts) {
          const line = part.replace(/^data: /, '').trim();
          if (!line || line.startsWith(':')) continue;
          try {
            const ev = JSON.parse(line);
            if (ev.type === 'progress') onProgress?.(ev.message);
            else if (ev.type === 'done')  return resolve(ev);
            else if (ev.type === 'error') return reject(new Error(ev.message));
          } catch {}
        }
      }
    } catch (e) { reject(e); }
  });
}

const match = (csvText, mapping, onProgress) =>
  sseStream(`${base}/sales.import/match`, { csvText, mapping }, onProgress);

const confirm = (payload) =>
  axios.post(`${base}/sales.import/confirm`, payload, { headers: authHeaders(), timeout: 30000 }).then(r => r.data);

const getHistory = () =>
  axios.get(`${base}/sales.import/history`, { headers: authHeaders() }).then(r => r.data);

const deleteImport = (id) =>
  axios.delete(`${base}/sales.import/${id}`, { headers: authHeaders() }).then(r => r.data);

const salesImportService = { preview, match, confirm, getHistory, deleteImport };
export default salesImportService;
